import React, { Component } from 'react';

import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';
import CircularProgress from '@material-ui/core/CircularProgress';

import CidadeService from '../../services/Cidade';
import { patternRegion } from '../../variables/Enums/Cidade';
import EnumService from '../../services/Enum';

import Filters from '../../components/Filters/Filters';
import Text from '../../components/Inputs/Text/Text';
import SelectOption from '../../components/Inputs/Select/Select';
import Toast from '../../components/Toast/Toast';

import { removePagingAndSorting } from '../../helper/PaginationHelper';

export class ProvaInvalidaFilter extends Component {
    constructor(props) {
        super(props);
        props.parentRef(this);
        this.state = {
            filters: {
                codigo: '',
                nome: '',
                cpf: '',
                regiao: '',
                motivo: '',
                statusTratamento: '',
            },
            count: 0,
            optionsMotivo: [],
            optionsStatusTratamento: [],
            optionsRegiao: [],
            loadingOptionsRegiao: false,
        }
    }

    setToast = t => this.Toast = t;

    handleChange = e => {
        this.setState({
            filters: { ...this.state.filters, [e.target.name]: e.target.value }
        });
    };

    handleFilterPersistence = (filters) => {
        filters = removePagingAndSorting(filters);

        const valorDe = field => filters.find(f => f.field === field) ? filters.find(f => f.field === field).value : "";

        this.setState({
            filters: {
                codigo: valorDe('codigo'),
                nome: valorDe('nome'),
                cpf: valorDe('cpf'),
                regiao: valorDe('regiao'),
                motivo: valorDe('motivo'),
                statusTratamento: valorDe('statusTratamento'),
            },
            count: filters.reduce((total, f) => f.value !== '' ? total + 1 : total, 0),
        })
    }

    handleFilterApply = () => {
        const f = [];
        const { filters } = this.state;

        if (filters.codigo) f.push({ field: 'codigo', value: filters.codigo })
        if (filters.nome) f.push({ field: 'nome', value: filters.nome })
        if (filters.cpf) f.push({ field: 'cpf', value: filters.cpf })
        if (filters.regiao) f.push({ field: 'regiao', value: filters.regiao })
        if (filters.motivo) f.push({ field: 'motivo', value: filters.motivo })
        if (filters.statusTratamento) f.push({ field: 'statusTratamento', value: filters.statusTratamento })

        this.props.handleFilterChange(f);
    }

    handleFilterClear = () => {
        this.setState({
            ...this.state,
            filters: {
                codigo: '',
                nome: '',
                cpf: '',
                regiao: '',
                motivo: '',
                statusTratamento: '',
            },
            count: 0,
        })

        this.props.handleFilterChange([], false);
    }

    handleCountFilters = () => this.state.count;

    carregarRegioes = () => {
        this.setState({ loadingOptionsRegiao: true });

        CidadeService.filterRegioes([])
            .then(res => this.setState({ optionsRegiao: [...patternRegion(res.data.content)] }))
            .catch(() => this.Toast.setState({
                message: {
                    message: "Não Foi Possível Buscar as Regiões.",
                    type: 'error',
                    open: true
                }
            }))
            .finally(() => this.setState({ loadingOptionsRegiao: false }))
    }

    async componentDidMount() {
        this.carregarRegioes();

        const statusTratamento = await EnumService.listarStatusTratamentoInvalidacao().then(res => res.data);
        const motivo = await EnumService.listarMotivosInvalidacao().then(res => res.data);

        this.setState({
            optionsStatusTratamento: [...statusTratamento],
            optionsMotivo: [...motivo],
        });
    }

    render() {
        return (
            <>
                <Toast parentRef={this.setToast} />

                <Filters
                    handleFilter={this.handleFilterApply}
                    handleFilterClear={this.handleFilterClear}
                    countFilters={this.handleCountFilters}
                >
                    <Grid item container spacing={3}>
                        <Grid item sm={12} lg={2}>
                            <Text
                                label="Código"
                                name='codigo'
                                value={this.state.filters.codigo}
                                onChange={(e) => this.handleChange(e)}
                            />
                        </Grid>

                        <Grid item sm={12} lg={4}>
                            <Text
                                label="Nome"
                                name='nome'
                                value={this.state.filters.nome}
                                onChange={(e) => this.handleChange(e)}
                            />
                        </Grid>

                        <Grid item sm={12} lg={2}>
                            <Text
                                label="CPF"
                                name='cpf'
                                value={this.state.filters.cpf}
                                onChange={(e) => this.handleChange(e)}
                            />
                        </Grid>

                        <Grid item sm={12} lg={2}>
                            <SelectOption
                                label="Região"
                                name='regiao'
                                value={this.state.filters.regiao}
                                onChange={(e) => this.handleChange(e)}
                                options={this.state.optionsRegiao}
                                disabled={this.state.loadingOptionsRegiao}
                                InputProps={{
                                    startAdornment: this.state.loadingOptionsRegiao ? <InputAdornment position="start"><CircularProgress size={18} /></InputAdornment> : null,
                                }}
                            />
                        </Grid>

                        <Grid item sm={12} lg={2}>
                            <SelectOption
                                label="Motivo"
                                name='motivo'
                                value={this.state.filters.motivo}
                                onChange={(e) => this.handleChange(e)}
                                options={this.state.optionsMotivo}
                            />
                        </Grid>

                        <Grid item sm={12} lg={3}>
                            <SelectOption
                                label="Status do Tratamento"
                                name='statusTratamento'
                                value={this.state.filters.statusTratamento}
                                onChange={(e) => this.handleChange(e)}
                                options={this.state.optionsStatusTratamento}
                            />
                        </Grid>
                    </Grid>
                </Filters>
            </>
        )
    }
}

export default ProvaInvalidaFilter;
